import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HisCoreSharedModule } from '../core/his-core-shared.module';

import { HisDisplayEmailComponent } from './component/his-display-email.component';
import { HisDisplayExpandableComponent } from './component/his-display-expandable.component';
import { HisDisplayPhoneComponent } from './component/his-display-phone.component';
import { HisDisplayTextComponent } from './component/his-display-text.component';
import { HisDisplayWeblinkComponent } from './component/his-display-weblink.component';
import { HisDisplayWebShareComponent } from './component/his-display-webshare.component';
import { HisDisplayCollapsibleTextViewComponent } from './component/his-display-collapsible-text-view.component';
import { HisDisplayCodeComponent } from './component/his-display-code/his-display-code.component';
import { HisTranslationSharedModule } from '../translation/his-translation-shared.module';
import { HisDisplayGridCalendarComponent } from './component/grid-calendar/his-display-grid-calendar.component';
import { HisDisplayGridCalendarMonthComponent } from './component/grid-calendar/his-display-grid-calendar-month.component';
import { HisDisplayGridCalendarDayComponent } from './component/grid-calendar/his-display-grid-calendar-day.component';
import { HisDisplayGridCalendarLegendComponent } from './component/grid-calendar/legend/his-display-grid-calendar-legend.component';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { DrawerModule } from 'primeng/drawer';
import { TableModule } from 'primeng/table';
import { CalendarModule } from 'primeng/calendar';

@NgModule( {
    imports: [
        CommonModule,
        FormsModule,
        HisCoreSharedModule,
        HisTranslationSharedModule,
        // PrimeNG
        OverlayPanelModule,
        DrawerModule,
        TableModule,
        CalendarModule,
        HisDisplayCodeComponent
    ],
    declarations: [
        HisDisplayCollapsibleTextViewComponent,
        HisDisplayEmailComponent,
        HisDisplayExpandableComponent,
        HisDisplayPhoneComponent,
        HisDisplayTextComponent,
        HisDisplayWeblinkComponent,
        HisDisplayWebShareComponent,
        HisDisplayGridCalendarComponent,
        HisDisplayGridCalendarMonthComponent,
        HisDisplayGridCalendarDayComponent,
        HisDisplayGridCalendarLegendComponent
    ],
    exports: [
        HisDisplayCollapsibleTextViewComponent,
        HisDisplayEmailComponent,
        HisDisplayExpandableComponent,
        HisDisplayCodeComponent,
        HisDisplayPhoneComponent,
        HisDisplayTextComponent,
        HisDisplayWeblinkComponent,
        HisDisplayWebShareComponent,
        HisDisplayGridCalendarComponent,
        HisDisplayGridCalendarMonthComponent,
        HisDisplayGridCalendarDayComponent,
        HisDisplayGridCalendarLegendComponent
    ]
} )
export class HisDisplaySharedModule { }
